import useStore from '@/stores/useStore.js'

export function useDefaultOrganizationId() {
  const organizations = useStore(state => state.organizations)

  const userId = useStore(state => state.user?.id)
  if (organizations.length === 0 || !userId) {
    return null
  }
  // we won't be doing org selector for now
  const defaultOrganizationId = organizations[0].id

  return defaultOrganizationId
}
